import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-animated-logo',
  template: `
    <svg viewBox="0 0 1024 1024">
      <rect class="node" style="--d:0.00" x="215" y="385" width="60" height="220" rx="30"/>
      <rect class="node" style="--d:0.06" x="325" y="270" width="60" height="220" rx="30"/>
      <rect class="node" style="--d:0.12" x="425" y="230" width="60" height="260" rx="30"/>
      <rect class="node" style="--d:0.18" x="530" y="230" width="60" height="260" rx="30"/>
      <rect class="node" style="--d:0.24" x="635" y="330" width="60" height="180" rx="30"/>
      <rect class="node" style="--d:0.30" x="745" y="400" width="60" height="130" rx="30"/>

      <rect class="node" style="--d:0.08" x="325" y="550" width="60" height="70" rx="30"/>
      <rect class="node" style="--d:0.14" x="420" y="615" width="60" height="70" rx="30"/>
      <rect class="node" style="--d:0.20" x="530" y="575" width="60" height="70" rx="30"/>
      <rect class="node" style="--d:0.26" x="625" y="575" width="60" height="70" rx="30"/>
      <rect class="node" style="--d:0.32" x="625" y="665" width="60" height="70" rx="30"/>
      <rect class="node" style="--d:0.38" x="745" y="615" width="60" height="70" rx="30"/>
    </svg>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      --orange: #E8791E;
      --orange-bright: #FF9838;
      --orange-dim: #F3C899;
    }

    svg {
      width: 100%;
      height: 100%;
      display: block;
      overflow: visible;
    }

    .node {
      fill: var(--orange-dim);
      animation: pulse 1.6s ease-in-out infinite;
      animation-delay: calc(var(--d) * 1s);
      transform-box: fill-box;
      transform-origin: center;
    }

    @keyframes pulse {
      0%   { fill: var(--orange-dim); filter: drop-shadow(0 0 0px transparent); transform: scale(1); }
      18%  { fill: var(--orange-bright);
              filter:
                drop-shadow(0 0 3px var(--orange-bright))
                drop-shadow(0 0 7px var(--orange));
              transform: scale(1.12); }
      36%  { fill: var(--orange-dim); filter: drop-shadow(0 0 0px transparent); transform: scale(1); }
      100% { fill: var(--orange-dim); filter: drop-shadow(0 0 0px transparent); transform: scale(1); }
    }
  `]
})
export class AnimatedLogoComponent {
  @Input() @HostBinding('style.width') width: string = '64px';
  @Input() @HostBinding('style.height') height: string = '64px';
}
